export const BUILD_PREVIEW = 'sitePreviews/BUILD_PREVIEW'
export const TAKE_SITE_BUILD_INFO = 'sitePreviews/TAKE_SITE_BUILD_INFO'
